import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { MatchKey } from '~hooks/useMatchKeys/models';

import { parseMatchKey } from './matchKeyFormat';

interface MatchKeysCellProps {
  matchKeys: MatchKey[] | null;
}

export default function MatchKeysCell({ matchKeys }: MatchKeysCellProps) {
  if (!matchKeys) {
    return null;
  }

  if (!matchKeys.length) {
    return (
      <Typography sx={{ color: 'text.secondary' }} variant="body2">
        {t('administration.match_keys.none')}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, overflow: 'hidden' }}>
      {matchKeys.map((matchKey) => {
        const { source, value } = parseMatchKey(matchKey.key);

        return (
          <Tooltip key={matchKey.id} title={matchKey.key}>
            <Chip label={source ? `${source}: ${value}` : value} size="small" />
          </Tooltip>
        );
      })}
    </Box>
  );
}
